import { History } from "lucide-react";
import QuestionCard from "./QuestionCard";
import RegenLoader from "@/components/shared/RegenLoader";
import { Button } from "@/components/ui/Button";
import Select from "@/components/ui/Select";

const QuestionSection = ({
  type,
  title,
  description,
  questions = [],
  hasQuestions,
  regenProgress,
  onRegenerate,
  needsSeniority,
  seniorityLevels = [],
  currentLevel,
  onLevelChange,
  isActive = true,
  canGenerateQuestions,
}) => {

  const showGenerator = !regenProgress && isActive;

  return (
    <div>
      {description && <p className="text-xs text-text-secondary mb-3">{description}</p>}

      {!isActive && hasQuestions && (
        <p className="text-xs text-text-secondary mb-3 italic">
          This question type was deactivated for the job. Previously generated questions are retained for reference.
        </p>
      )}

      {regenProgress ? (
        <RegenLoader progress={regenProgress} />
      ) : !hasQuestions ? (
        <div className="flex flex-col items-center justify-center py-10 gap-4">
          {canGenerateQuestions && <p className="text-text-secondary text-sm text-center">No {title.toLowerCase()} generated yet.</p>}
          {showGenerator &&
            (canGenerateQuestions ? (
              <div className="flex items-center gap-3">
                {needsSeniority && seniorityLevels.length > 0 && (
                  <Select
                    value={currentLevel}
                    onChange={(value) => onLevelChange?.(value)}
                    options={seniorityLevels}
                    className="h-10 rounded-lg px-3 py-2.5 text-xs"
                  />
                )}

                <Button
                  className="bg-background-tertiary hover:bg-button-secondary hover:text-text-base text-text-primary px-5 py-3 flex items-center gap-2 rounded-full text-xs md:text-sm"
                  onClick={onRegenerate}
                >
                  <History size={15} />
                  <p>Generate</p>
                </Button>
              </div>
            ) : (
              <div className="flex flex-col items-center gap-4 text-center">
                <div className="flex flex-col gap-1">
                  <p className="text-sm font-medium text-text-primary">Question generation unavailable</p>
                  <p className="text-xs text-text-secondary max-w-xs leading-relaxed">
                    This feature is currently unavailable. Please try again later.
                  </p>
                </div>
              </div>
            ))}
        </div>
      ) : (
       <div
          className="space-y-3"
        >
          {questions.map((question, index) => (
            <QuestionCard
              key={index}
              question={question}
              globalIndex={index}
              localIndex={index}
              type={type}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionSection;
